import * as React from 'react';
import styled from 'styled-components';

import { User } from '../../../typedefs/store';
import colors from '../../colors';
import Title from './Title';
const sample = require('lodash.sample');

interface Props {
    locationName: string;
    onMinimize?: (e: React.MouseEvent<HTMLElement>) => any;
    onClose?: (e: React.MouseEvent<HTMLElement>) => any;
    avatar: string;
    agent?: User;
    starters: string[];
    ended: boolean;
}

class Header extends React.Component<Props, {}> {
    private starter?: string;

    componentWillMount() {
        this.starter = sample(this.props.starters);
    }

    render() {
        const { onMinimize, onClose, locationName, avatar, agent, starters, ended } = this.props;
        return (
            <Wrapper>
                <Title>{locationName}</Title>
                {agent ? (
                    <AgentWrapper>
                        {!ended ? (
                            <div>You're having a conversation with {agent.name}</div>
                        ) : (
                            <div>Your conversation with {agent.name} has ended</div>
                        )}
                        <Avatar src={avatar} />
                    </AgentWrapper>
                ) : (
                    <StarterWrapper>{this.starter}</StarterWrapper>
                )}
            </Wrapper>
        );
    }
}

export default Header;

const Wrapper = styled.div`
    text-align: center;
    padding-bottom: 2em;
    margin-bottom: 2em;
    border-bottom: 1px solid ${colors.lightGray};
`;

const AgentWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 40px 0 40px;
`;

const StarterWrapper = styled.div`
    align-items: center;
    justify-content: center;
    margin: 20px 0 0 0;
`;

const Avatar = styled.img`
    display: block;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    flex-shrink: 0;
    margin-left: 15px;
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Conversation/Sidebar/Header.tsx